module.exports = __webpack_public_path__ + "static/media/SpoqaHanSansNeo-Bold.d57ff6f2.woff2";